import React, { useEffect, useState, useRef } from 'react'
import { twoDecimalPlaces, productLogInClick, adjustLeft } from './HelperFunctions'
import { SupplyListModal } from './Modals/SupplyListModal';
import { AddToCartModal } from './Modals/AddToCartModal';
import { OnlySupplyListModal } from './Modals/RestrictionModals/OnlySupplyListModal';
import { OnAllocationModal } from './Modals/RestrictionModals/OnAllocationModal';
import { OnlyContractModal } from './Modals/RestrictionModals/OnlyContractModal';
import { ImageModal } from "./Modals/ImageModal"
import { AjaxPost } from "../../Services/index";

export const CustomizeOrder = ({ items, setItems }) => {
    const keyword = useRef(null);
    const didScroll = useRef(null);
    const lastScrollTop = useRef(0);
    const delta = useRef(5);
    const navbarHeight = useRef(0);
    const usingSupplyList = useRef(false);
    const [itemsToSupplyList, setItemsToSupplyList] = useState(null);
    const [updateCart, setUpdateCart] = useState(null);
    useEffect(() => {
        window.onbeforeunload = handleLeavePage;

        navbarHeight.current = $('#customize-order-header').outerHeight();
        $(window).on("scroll", setScroll);
        const customizeOrderInterval = setInterval(function () {
            if (didScroll.current) {
                hasScrolled();
                didScroll.current = false;
            }
        }, 20);

        return () => {
            window.onbeforeunload = null;
            clearInterval(customizeOrderInterval);
            $(window).off("scroll", setScroll);
        }
    }, [items]);

    useEffect(() => {
        updateSelectedItems(items);
        if (updateCart && !!updateCart.ItemList.length) keyword.current = null;
    }, [items, updateCart]);

    useEffect(() => {
        //Check whether page opened from search
        const searchSplitTry1 = document.referrer.split('Search/');
        if (searchSplitTry1.length === 2) keyword.current = searchSplitTry1[1];
        else {
            const searchSplitTry2 = document.referrer.split('Search?keyword=');
            if (searchSplitTry2.length === 2) keyword.current = searchSplitTry2[1];
            else {
                const splitCurrentPath = window.location.href.split('/');
                keyword.current = splitCurrentPath[splitCurrentPath.length - 1];
            }
        }
    }, []);

    return (
        <div id="items-table">
            {!items ?
                <div className="siteloader loading-heartbeat tk-trade-gothic-next tw-text-center md:tw-pb-[17px] tw-text-[14.5px] md:tw-text-[16px] tw-mt-[34px] tw-block"
                    style={{ color: "red", gridColumn: "1 / span 2" }} />
                : items.length == 0
                    ? <div>No items found.</div>
                    : <>
                        {!!itemsToSupplyList?.length && <SupplyListModal itemsToSupplyList={itemsToSupplyList} setItemsToSupplyList={setItemsToSupplyList} />}
                        {!!updateCart &&
                            <div className="tw-fixed tw-flex tw-flex-col tw-items-center tw-justify-center tw-z-[18] tw-top-0 tw-bottom-0 tw-right-0 tw-left-0 tw-m-auto tw-h-[100%] tw-w-[100%] "
                                style={{ backgroundColor: "rgba(0,0,0,0.4)" }} aria-labelledby="supplyListModalLabel" onClick={closeModal}>
                                <div className="tw-overflow-y-auto tw-overflow-x-hidden tw-bg-white">
                                    <AddToCartModal updateCart={updateCart} setUpdateCart={setUpdateCart} setItems={setItems} />
                                    <OnAllocationModal updateCart={updateCart} setUpdateCart={setUpdateCart} setItems={setItems} />
                                    <OnlySupplyListModal updateCart={updateCart} setUpdateCart={setUpdateCart} setItems={setItems} />
                                    <OnlyContractModal updateCart={updateCart} setUpdateCart={setUpdateCart} setItems={setItems} />
                                </div>
                            </div>
                        }
                        <div id='customize-order-header' className={"tw-flex tw-justify-between tw-items-center tw-bg-white tw-z-[1] " + (window.innerWidth >= 992 && "customize-order-nav-down stickable-header")}>
                            <div className="tw-text-[25px] md:tw-text-[32px] tw-text-tamarillo-700 tw-font-bold tk-trade-gothic-next-condensed">
                                Choose Options
                            </div>
                            {window.innerWidth >= 992 && <AddButtons items={items} setItemsToSupplyList={setItemsToSupplyList} setUpdateCart={setUpdateCart} usingSupplyList={usingSupplyList} />}
                        </div>
                        {window.innerWidth >= 992
                            ? <DesktopTable items={items} keyword={keyword} usingSupplyList={usingSupplyList} />
                            : <MobileTable items={items} keyword={keyword} usingSupplyList={usingSupplyList} />}
                        {window.innerWidth < 992 && <AddButtons items={items} setItemsToSupplyList={setItemsToSupplyList} setUpdateCart={setUpdateCart} usingSupplyList={usingSupplyList} />}
                    </>
            }
        </div>
    );

    function setScroll() {
        didScroll.current = true;
    }

    function closeModal(e) {
        if (e.target !== e.currentTarget) return;
        setUpdateCart(null)
    }

    function handleLeavePage(e) {
        if (!productModel.IsAuthenticated || usingSupplyList.current) return;
        $('[id^="quantity-"]').each(function (i, row) {
            const quantity = parseInt($(row).val());
            var indexes = row.id.split('-');
            const currUoM = items[indexes[1]]?.UoMPrices[indexes[2]];
            const qtyDiff = quantity - currUoM.QtyOrdered;
            if (qtyDiff) {
                e.preventDefault();
                e.returnValue = '';
                //setUpdateCart({ Cart: null, ItemList: [] });
                return false;
            }
        });
    }

    function hasScrolled() {
        var st = $(window).scrollTop();
        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop.current - st) <= delta.current) return;

        // If they scrolled down and are past the navbar, add class .nav-up. This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop.current && st > navbarHeight.current) $('#customize-order-header').removeClass('customize-order-nav-up').addClass('customize-order-nav-down'); // Scroll Down
        else if (st + $(window).height() < $(document).height()) $('#customize-order-header').removeClass('customize-order-nav-down').addClass('customize-order-nav-up'); // Scroll Up
        lastScrollTop.current = st;
    }
}

const DesktopTable = ({ items, keyword, usingSupplyList }) => {

    let accesoryCutIndex = -1;
    let nonAccesories = [], accesories = [];
    if (!!items) {
        accesoryCutIndex = items.map(item => item.AccesoryCut).indexOf(true);
        if (accesoryCutIndex === -1) {
            nonAccesories = items;
        }
        else {
            nonAccesories = items.slice(0, accesoryCutIndex);
            accesories = items.slice(accesoryCutIndex);
        }
    }

    return (
        <table className="tw-w-full tw-mt-[18px] lg:tw-mt-[25px] tw-text-[#282828]">
            <colgroup>
                <col span="1" className="tw-w-[11%]" />
                <col span="1" className="tw-w-[38%] xxxl:tw-w-[43%]" />
                <col span="1" className="tw-w-[6%]" />
                <col span="1" className="tw-w-[7%]" />
                <col span="1" className="tw-w-[19%] xxxl:tw-w-[14%]" />
                <col span="1" className="tw-w-[9%]" />
                <col span="1" className="tw-w-[10%]" />
            </colgroup>
            <tbody>
                <tr className="tw-text-[14px] tw-font-bold tw-leading-[15px]">
                    <td></td>
                    <td className="tw-text-center tw-pb-[8px]"></td>
                    <td></td>
                    <td className="tw-pb-[8px] tw-pl-[22px]"></td>
                    <td></td>
                    <td className="tw-pb-[8px] tw-items-end tw-flex">
                        <span style={{ textWrapMode: "nowrap" }}>Stock Status &nbsp;</span>
                        <span className="tw-relative tw-h-[19px] tw-w-[20px] tw-font-medium tw-flex tw-justify-center tw-group tw-cursor-pointer tw-text-[16px]"
                            style={{ border: "1.5px solid #A71635", borderRadius: "20px", color: "#A71635" }}>
                            ?
                            <div className="group-hover:tw-block tw-z-[1] tw-absolute tw-bottom-[20px] tw-font-normal" style={{ display: "none" }}>
                                <div style={{ borderRadius: "5px" }} className="tw-bg-mine-shaft-950 tw-w-[233px] tw-px-[15px] tw-pt-[7px] tw-pb-[25px] tw-text-white tw-text-[13px] tw-z-[18]">
                                    <div style={{ borderBottom: "2px solid #A71636" }} className="tw-text-[15px] tw-pb-[4px] tw-mb-[14px] tw-font-bold">
                                        Stock Status
                                    </div>
                                    <div className="tw-flex tw-flex-col tw-gap-[10px]">
                                        <div className="tw-flex tw-gap-[9px] tw-items-center">
                                            <img className="tw-w-[21px]" src="/Content/img/sprites/instock-alert.svg" />In Stock
                                        </div>
                                        <div className="tw-flex tw-gap-[9px] tw-items-center">
                                            <img className="tw-w-[21px] tw-h-[21px] tw-rounded-xl tw-p-[1px] tw-bg-white"
                                                src="/Content/img/sprites/shipsupplier-black.svg" />Ships Direct From Supplier
                                        </div>
                                        <div className="tw-flex tw-gap-[9px] tw-items-center">
                                            <img className="tw-w-[21px]" src="/Content/img/sprites/item-allocation.svg" />Item Is on Allocation
                                        </div>
                                        <div className="tw-flex tw-gap-[9px] tw-items-center">
                                            <img className="tw-w-[21px]" src="/Content/img/sprites/item-is-backorder.svg" />Item Is on Extended Backorder
                                        </div>
                                        <div className="tw-flex tw-gap-[9px] tw-items-center">
                                            <img className="tw-w-[21px]" src="/Content/img/sprites/estimated-ship-alert.svg" />Estimated Ship Date
                                        </div>
                                        <div className="tw-flex tw-gap-[9px] tw-items-center">
                                            <img className="tw-w-[21px]" src="/Content/img/sprites/expiration-date-red.svg" />Sensitive Expiration Date
                                        </div>
                                    </div>
                                </div>
                                <div className="triangle-down tw-m-auto"></div>
                            </div>
                        </span>
                    </td>
                    <td></td>

                </tr>
                {nonAccesories.map((item, i) =>
                    <ItemDetailRow key={`nonaccesory-item-${i}`} item={item} keyword={keyword} index={i} items={items} usingSupplyList={usingSupplyList} />
                )}
                {!!accesories.length && <>
                    <tr colSpan="6" className="accessory tw-leading-[80px] tw-text-[32px] tw-text-tamarillo-700 tw-pt-[12px] tw-font-bold tk-trade-gothic-next-condensed tw-text-nowrap">
                        <td>Common Accessories</td>
                    </tr>
                    {accesories.map((item, i) =>
                        <ItemDetailRow key={`accesory-item-${i}`} item={item} keyword={keyword} index={i + accesoryCutIndex} items={items} usingSupplyList={usingSupplyList} />
                    )}
                </>}
            </tbody>
        </table >
    )
}

const ItemDetailRow = ({ item, keyword, index, items, usingSupplyList }) => {
    const prevValue = useRef(0);
    const [bigImgName, setBigImgName] = useState("");
    return (
        <>
            {!!bigImgName && <ImageModal bigImgName={bigImgName} setBigImgName={setBigImgName} />}
            <tr className="tw-h-[108px] item-detail-row"
                style={item.SDsku.localeCompare(keyword.current, undefined, { sensitivity: 'base' }) === 0
                    ? { border: "4px solid #f5ec8e" }
                    : index === 0 ? { borderTop: "1px solid #DDDDDD", borderBottom: "1px solid #DDDDDD" } : { borderBottom: "1px solid #DDDDDD" }}>
                {/*Image*/}
                <td className="tw-cursor-zoom-in" onClick={() => setBigImgName(item.ImageName)} >
                    <img className="tw-min-w-[120px] tw-h-[90px]" src={`/Content/ProductImages/120x90/${item.ImageName}`} title={item.SDname} alt={item.ItemAltText} />
                    <img className="tw-w-[16px] tw-mt-[-16px]" src="/Content/img/sprites/zoom-in.png" />
                </td>
                <td>
                    <div className="tw-flex tw-flex-col tw-justify-center tw-py-[6px] xl:tw-py-0 tw-gap-[6px]">
                        {/*Item Description*/}
                        <div className="tw-font-bold tw-text-[17px] xl:tw-text-[18px] tw-mb-[2px] tw-leading-[19px] tw-my-[5px] xl:tw-my-0">{item.SDname}</div>
                        <div className="tw-flex tw-text-[12.6px] xl:tw-text-[14px] tw-text-[#858585] tw-font-light tw-gap-[16px]">
                            <div className={"tw-relative tw-leading-[13px] tw-text-center after:tw-opacity-[.55] after:tw-w-[2px] after:tw-h-[62%] after:tw-bg-[#858585] after:xxl:tw-h-[86%] after:tw-top-[6px] after:xxl:tw-top-[1px] after:tw-right-[-10px] after:tw-absolute tw-flex tw-flex-wrap tw-justify-center tw-text-[#A71635] tw-gap-x-[4px] tw-font-normal " + (item.SDsku.localeCompare(keyword.current, undefined, { sensitivity: 'base' }) === 0 && "tw-bg-[#f5ec8e]")}>
                                <span>Item ID:</span><span>{item.SDsku}</span>
                            </div>
                            <div className="tw-flex tw-flex-wrap tw-justify-center tw-gap-x-[4px] tw-text-center tw-leading-[13px] tw-relative after:tw-opacity-[.55] after:tw-w-[2px] after:tw-h-[62%] after:tw-bg-[#858585] after:xxl:tw-h-[86%] after:tw-top-[6px] after:xxl:tw-top-[1px] after:tw-right-[-10px] after:tw-absolute"><span>MFG#:</span><span>{item.VendItemNo}</span></div>
                            <div className="tw-flex tw-flex-wrap tw-justify-center tw-gap-x-[4px] tw-text-center tw-leading-[13px]"><span>MFG:</span><span>{item.VendName}</span></div>
                        </div>
                        {/*Allocations*/}
                        {(productModel.IsAuthenticated && !!item.QtyEAtoAlloc) &&
                            <div className="tw-text-[12.6px] xl:tw-text-[14px] tw-text-[#858585] tw-font-light">
                                {`Monthly Allocation: ${item.QtyEAtoAlloc} / Quantity Remaining: ${item.QtyAvail}`}
                            </div>
                        }
                    </div>
                </td>
                {/*Medical direction*/}
                <td className="tw-text-center">{item.Rx && <img className="tw-w-[19px] tw-m-auto" src="/Content/img/sprites/rx.svg" />}</td>
                <td className="tw-py-[14px]">
                    {item.UoMPrices.map((uom, k) =>
                        <div key={`medical-direction-${k}`} className="tw-text-[15px] tw-h-[45px] tw-content-center">
                            <div className="tw-leading-[15px] tw-font-bold tw-mb-[-5px]">{uom.UMDesc === 'bx' ? 'Box of' : uom.UMDesc === 'cs' ? 'Case of' : "Single"}</div>
                            <div className="tw-leading-[14px] tw-mt-[7px]">{uom.UMDesc === "ea" ? "1 each" : uom.UMQty + " each"}</div>
                        </div>
                    )}
                </td>
                {/*Price*/}
                <td className="tw-py-[14px]">
                    {item.UoMPrices.map((uom, k) =>
                        <div key={`item-price-${k}`} className={"tw-h-[45px] tw-content-center " + (item.OnContract ? "tw-flex-col" : "tw-items-center")}>
                            {item.OnContract
                                ? <>
                                    <div className="tw-text-[15px] tw-font-bold">Your Price: <span className="tw-text-[#62A94B]">${twoDecimalPlaces(uom.Price)}</span></div>
                                    <div className="tw-text-[12px] tw-text-[#858585]">List price: ${twoDecimalPlaces(uom.ListPrice)}</div></>
                                :
                                <><div className="tw-text-[14px] xl:tw-text-[15px] tw-font-bold tw-leading-[18px]">List Price: ${twoDecimalPlaces(uom.Price)}</div>
                                    {!productModel.IsAuthenticated &&
                                        <div className="tw-flex tk-trade-gothic-next tw-text-mine-shaft-1000 tw-text-[12px] tw-font-medium">
                                            <span onClick={productLogInClick} className="productLogIn tw-text-tamarillo-700 tw-cursor-pointer">
                                                Log In
                                            </span><span className="tw-text-[#858585]">&nbsp;for Your Price</span>
                                        </div>
                                    }</>
                            }
                        </div>
                    )}
                </td>
                <td><StockStatus item={item} /></td>
                <td className="tw-py-[14px]">
                    {item.UoMPrices.map((uom, k) =>
                        <div key={`price-input-${k}`} className="tw-justify-end tw-py-[4px] tw-flex">
                            <div className="tw-flex tw-items-center tw-text-[15px] tw-text-center tw-w-[125px]"
                                style={uom.QtyOrdered > 0 ? { border: "1.5px solid #62A94B" } : { border: "1.5px solid #E2E2E2" }}>
                                <div className="tw-text-tamarillo-700 tw-basis-[28%] tw-h-[35px] tw-content-center tw-bg-[#F5F4F2] tw-font-bold tw-cursor-pointer"
                                    style={{ borderRight: "1.5px solid #E2E2E2" }} onClick={(e) => changeQuantity(-1, e, items, usingSupplyList)}>
                                    –
                                </div>
                                <input id={`quantity-${index}-${k}`} type="text" className="tw-outline-none tw-flex tw-basis-[64%] tw-w-full tw-text-center tw-border-0"
                                    placeholder="0" onKeyDown={(e) => handleKeyDown(e, item, usingSupplyList)} onInput={(e) => handleInput(e, prevValue, items, usingSupplyList)} defaultValue={uom.QtyOrdered} />
                                <div className="tw-text-tamarillo-700 tw-basis-[28%] tw-h-[35px] tw-content-center tw-bg-[#F5F4F2] tw-font-bold tw-cursor-pointer"
                                    style={{ borderLeft: "1.5px solid #E2E2E2" }} onClick={(e) => changeQuantity(1, e, items, usingSupplyList)}>
                                    +
                                </div>
                            </div>
                        </div>
                    )}
                </td>
            </tr>
        </>
    )
}

const MobileTable = ({ items, keyword, usingSupplyList }) => {
    const prevValue = useRef(0);
    const [bigImgName, setBigImgName] = useState("");

    return (<>
        {!!bigImgName && <ImageModal bigImgName={bigImgName} setBigImgName={setBigImgName} />}
        <div className="tw-w-full tw-text-[#282828]">
            {items.map((item, i) =>
                <div key={`mobile-item-row-${i}`}>
                    {item.AccesoryCut &&
                        <div colSpan="3" className="accessory tw-text-[32px] tw-text-tamarillo-700 tw-pt-[12px] tw-font-bold tk-trade-gothic-next-condensed tw-text-nowrap">
                            Common Accessories
                        </div>
                    }
                    <div className="tw-flex tw-flex-col tw-gap-[22px] tw-py-[22px] sm:tw-px-[20%] lg:tw-px-0"
                        style={item.SDsku.localeCompare(keyword.current, undefined, { sensitivity: 'base' }) === 0
                            ? { border: "4px solid #f5ec8e" }
                            : { borderBottom: "1px solid #DDDDDD" }}>
                        {/*1st row*/}
                        <div className="tw-flex tw-gap-[18px]">
                            {/*1st column*/}
                            <div className="tw-flex tw-flex-col tw-gap-[3px]">
                                <StockStatus item={item} />
                                <div className="tw-cursor-zoom-in" onClick={() => setBigImgName(item.ImageName)} >
                                    <img className="tw-min-w-[124px] tw-h-[93px]" src={`/Content/ProductImages/120x90/${item.ImageName}`} title={item.SDname} alt={item.ItemAltText} />
                                    <img className="tw-w-[16px]" src="/Content/img/sprites/zoom-in.png" />
                                </div>
                            </div>
                            {/*2nd column*/}
                            <div className="tw-flex tw-flex-col tw-gap-[3px]">
                                {/*Item Description*/}
                                <div className="tw-font-bold tw-text-[18px] tw-mb-[3px] tw-leading-[20px]">{item.SDname}</div>
                                <div className="tw-flex tw-text-[12px] tw-text-[#858585] tw-font-light tw-gap-x-[16px] tw-flex-wrap tw-max-w-[300px] sm:tw-w-auto tw-leading-[16px]">
                                    <div className={"tw-relative tw-flex tw-justify-center tw-text-[#A71635] tw-gap-x-[4px] tw-font-normal after:tw-opacity-[.55] after:tw-w-[2px] after:tw-h-[62%] after:tw-bg-[#858585] after:tw-top-[4px] after:tw-right-[-10px] after:tw-absolute "
                                        + (item.SDsku.localeCompare(keyword.current, undefined, { sensitivity: 'base' }) === 0 && "tw-bg-[#f5ec8e]")}>
                                        Item ID:&nbsp;{item.SDsku}
                                    </div>
                                    <div className="tw-flex tw-justify-center tw-gap-x-[4px] tw-relative after:tw-opacity-[.55] after:tw-w-[2px] after:tw-h-[62%] after:tw-bg-[#858585] after:tw-top-[4px] after:tw-right-[-10px] after:tw-absolute"><span>MFG#:</span><span>{item.VendItemNo}</span></div>
                                    <div className="tw-flex tw-justify-center tw-gap-x-[4px]"><span>MFG:</span><span>{item.VendName}</span></div>
                                </div>
                                {/*Medical direction*/}
                                {item.Rx &&
                                    <div className="tw-flex tw-items-end">
                                        <img className="tw-w-[15px] tw-mt-[10px]" src="/Content/img/sprites/rx.svg" />&nbsp;<span className="tw-text-[13px]">Medical Direction</span>
                                    </div>
                                }
                            </div>
                        </div>

                        {/*2nd row*/}
                        <div className="tw-flex tw-flex-col tw-gap-[8px]">
                            {item.UoMPrices.map((uom, k) =>
                                <div key={`mobile-uom-price-${k}`} className="tw-flex tw-gap-[38px] tw-items-center">
                                    {/*1st column*/}
                                    <div className="tw-flex tw-flex-col tw-w-[150px] lg:tw-max-w-auto">
                                        {/*UoM*/}
                                        <div className="tw-text-[16px] tw-font-bold tw-mb-[3px]">
                                            {(uom.UMDesc === 'bx' ? 'Box of ' : uom.UMDesc === 'cs' ? 'Case of ' : "Single") + (uom.UMDesc !== "ea" ? uom.UMQty + " each" : '')}
                                        </div>
                                        {/*Price*/}
                                        <div className={"tw-content-center " + (item.OnContract ? "tw-flex-col" : "tw-items-center")}>
                                            {item.OnContract
                                                ? <>
                                                    <div className="tw-text-[15px]">Your Price: <span className="tw-text-[#62A94B]">${twoDecimalPlaces(uom.Price)}</span></div>
                                                    <div className="tw-text-[13px] tw-text-[#858585]">List price: ${twoDecimalPlaces(uom.ListPrice)}</div></>
                                                : <>
                                                    <div className="tw-text-[15px] tw-leading-[15px]">List Price: ${twoDecimalPlaces(uom.Price)}</div>
                                                    {!productModel.IsAuthenticated &&
                                                        <div className="tw-flex tk-trade-gothic-next tw-text-mine-shaft-1000 tw-text-[13px] tw-font-medium">
                                                            <span onClick={productLogInClick} className="productLogIn tw-text-tamarillo-700 tw-cursor-pointer">
                                                                Log In
                                                            </span><span className="tw-text-[#858585]">&nbsp;for Your Price</span>
                                                        </div>
                                                    }</>
                                            }
                                        </div>
                                    </div>
                                    {/*2nd column*/}
                                    <div className="tw-flex tw-items-center tw-text-[15px] tw-text-center tw-w-[168px] tw-h-[56px]"
                                        style={uom.QtyOrdered > 0 ? { border: "1.5px solid #62A94B" } : { border: "1.5px solid #E2E2E2" }}>
                                        <div className="tw-text-tamarillo-700 tw-w-[46px] tw-h-[53px] tw-content-center tw-bg-[#F5F4F2] tw-text-[18px]tw-cursor-pointer"
                                            style={{ borderRight: "1.5px solid #E2E2E2" }} onClick={(e) => changeQuantity(-1, e, items, usingSupplyList)}>
                                            –
                                        </div>
                                        <input id={`quantity-${i}-${k}`} type="text" className="tw-outline-none tw-flex tw-basis-[64%] tw-w-full tw-text-center tw-border-0"
                                            placeholder="0" onKeyDown={(e) => handleKeyDown(e, items, usingSupplyList)} onInput={(e) => handleInput(e, prevValue, items, usingSupplyList)} defaultValue={uom.QtyOrdered} />
                                        <div className="tw-text-tamarillo-700 tw-w-[46px] tw-self-center tw-h-[53px] tw-content-center tw-bg-[#F5F4F2] tw-text-[18px] tw-cursor-pointer"
                                            style={{ borderLeft: "1.5px solid #E2E2E2" }} onClick={(e) => changeQuantity(1, e, items, usingSupplyList)}>
                                            +
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div >
                </div>)}
        </div >
    </>)
}

export const ViewAlts = ({ item, mainWindow }) => {
    return !!item.AltItemList?.length &&
        <div className={"tw-text-[12px] tw-text-[#5B5B5B] tw-leading-[12px] " + (mainWindow && "tw-relative tw-group")} onClick={(e) => adjustLeft(e, mainWindow)} onMouseOver={(e) => adjustLeft(e, mainWindow)}>
            <i className="view-alternatives tw-cursor-pointer tw-not-italic">View Alternatives</i>
            <div className={"tw-flex-col tw-gap-[10px] customize-order-tooltip "
                + (mainWindow ? "group-hover:tw-flex tw-bottom-[22px]" : "group-hover tw-left-0 tw-right-0 tw-top-0 tw-bottom-0 tw-m-auto tw-h-fit")}>
                {item.AltItemList.map((altItem, i) =>
                    <div key={`alt-item-${i}`} className={"tw-flex tw-gap-[8px] tw-items-center tw-cursor-pointer " + (i !== 0 && "tw-pt-[9px]")}
                        style={i !== 0 ? { borderTop: "1.5px solid #dddddd" } : {}}
                        onClick={() => window.open(altItem.ProductUrl + altItem.ItemID, '_blank').focus()}>
                        <img alt="Item Image" src={`/Content/ProductImages/80x60/${altItem.ImageName}`} />
                        <div className="tw-flex tw-flex-col tw-gap-[4px] hover:tw-text-tamarillo-700">
                            <div>
                                {altItem.Heading}
                            </div>
                            <div>
                                {altItem.ItemID}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
}

const StockStatus = ({ item }) => {
    return (
        <div className="tw-text-[#5B5B5B] tw-font-light tw-w-fit tw-flex tw-items-center tw-gap-[8px]">
            {(item.WebDisplayStatus === 'IN STOCK' && item.Status !== 'IN STOCK') &&
                <div className="tw-group tw-relative" onMouseOver={(e) => adjustLeft(e)}>
                    <i className="text-success fas fa-check-circle" />{' '}<span className="tw-text-[12px]">In Stock</span>
                    <div className="customize-order-tooltip group-hover:tw-block">Item is in stock</div>
                </div>
            }
            <div className="tw-group tw-relative tw-flex tw-gap-[5px] tw-items-end" onMouseOver={(e) => adjustLeft(e)}>
                {item.Status === 'IN STOCK' &&
                    <><i className="text-success fas fa-check-circle" />{' '}<span className="tw-text-[12px]">In Stock</span>
                        <div className="customize-order-tooltip group-hover:tw-block">Item is in stock</div></>}
                {item.Status === 'ALERT' ? <>
                    {item.AlertType === "Expiring" ?
                        <i className="fas fa-hourglass-half tw-group tw-text-[18px]" >
                            {!!item.ALERTExpStatus &&
                                <div className="customize-order-tooltip group-hover:tw-block">
                                    <div className="tw-font-bold">Please Note:</div>
                                    <div>{item.ALERTExpStatus.replace(/"/g, "&quot;").replace(/'/g, "&#39;")}</div>
                                </div>
                            }
                        </i>
                        : item.AlertType === "Allocation" ?
                            <i className="text-danger fa fa-bullhorn" >
                                <div className="customize-order-tooltip group-hover:tw-block">
                                    <div className="tw-flex tw-flex-col tw-gap-[2px]">{htmlBackorder(item)}</div>
                                </div>
                            </i>
                            : item.AlertType === "Backorder" &&
                            <i className="text-danger fas fa-exclamation-triangle" >
                                <div className="customize-order-tooltip group-hover:tw-block">
                                    <div className="tw-flex tw-flex-col tw-gap-[2px]">{htmlBackorder(item)}</div>
                                </div>
                            </i>
                    }</>
                    : item.Status === 'INFO' ?
                        <i className="text-warning fas fa-info-circle" >
                            {!!item.INFOEstShipDate &&
                                <div className="customize-order-tooltip group-hover:tw-block">
                                    <div className="tw-font-bold">Est. Ship Date:</div>
                                    <div>{item.INFOEstShipDate}</div>
                                </div>
                            }
                        </i>
                        : item.Status === 'DIRECTSHIP' && <>
                            <img src=" /Content/img/sprites/shipsupplier-black.svg" className="tw-h-[23px]" />{' '}
                            <div className="customize-order-tooltip group-hover:tw-block">Ships direct from supplier</div>
                        </>
                }
            </div>
            <div className="tw-group tw-relative" onMouseOver={(e) => adjustLeft(e)}>
                {(item.isSensitiveExpirationDate == 1 && !(item.Status === 'ALERT' && item.AlertType === "Expiring")) &&
                    <i className="fas fa-hourglass-half tw-group tw-text-[18px]" >
                        {!!item.ALERTExpStatus &&
                            <div className="customize-order-tooltip group-hover:tw-block">
                                <div className="tw-font-bold">Please Note:</div>
                                <div>{item.ALERTExpStatus.replace(/"/g, "&quot;").replace(/'/g, "&#39;")}</div>
                            </div>
                        }
                    </i>
                }
            </div>
            <ViewAlts item={item} mainWindow={true} />
        </div>
    );
}

const SelectedItems = () => {
    return (
        <div id='selected-items' style={{ visibility: 'hidden' }}
            className="tw-font-bold tw-text-[19px] md:tw-text-[17px] lg:tw-text-[14px] tw-pb-[8px] tw-pt-[13px] lg:tw-pt-0 tw-text-center sm:tw-text-end">
            <span className="tw-text-tamarillo-700"></span>&nbsp;<span>items selected</span>
        </div>
    )
}

const AddButtons = ({ items, setItemsToSupplyList, setUpdateCart, usingSupplyList }) => {
    return (
        <div className="tw-flex tw-flex-col lg:tw-flex-row tw-pt-[35px] lg:tw-pt-[30px] tw-gap-[14px] tw-justify-end tw-items-center ">
            {(!productModel.IsAuthenticated || productModel.RoleRecNo != "1") &&
                <div id="add-to-supply-list" style={{ border: "1.5px solid #A71636" }}
                    onClick={() => { if (productModel.IsAuthenticated && productModel.RoleRecNo != "1") addToSupplyList(); else productLogInClick(); }}
                    className="tw-cursor-pointer tw-w-full sm:tw-w-[198px] tw-h-[41px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-font-bold tw-text-[14px] sm:tw-text-[16px] hover:tw-bg-tamarillo-700 hover:tw-text-white tw-order-1 lg:tw-order-none">
                    Add to supply list
                </div>
            }
            <div className="add-buttons-cart tw-cursor-pointer tw-w-full sm:tw-w-[198px] tw-h-[41px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[14px] sm:tw-text-[16px]"
                onClick={() => { if (productModel.IsAuthenticated) updateCart(); else productLogInClick(); }}>
                {window.innerWidth >= 576 ? 'Update Cart' : 'Add To Cart'}
            </div>
        </div >
    )

    function addToSupplyList() {
        const itemsForSupplyList = [];
        usingSupplyList.current = true;
        $('[id^="quantity-"]').each(function (i, row) {
            const quantity = parseInt($(row).val());
            if (quantity) {
                var indexes = row.id.split('-');
                if (!items[indexes[1]]) return true;
                const currItem = items[indexes[1]];
                const currUoM = currItem.UoMPrices[indexes[2]];
                const [itemName, description] = currItem.SDname.split(',');
                currUoM.ItemName = itemName;
                currUoM.Description = description;
                currUoM.ImageName = currItem.ImageName;
                currUoM.ItemGroupRecNo = productModel.ItemGroupRecNo;
                currUoM.displayQty = quantity;
                itemsForSupplyList.push(currUoM);
            }
        });
        setItemsToSupplyList([...itemsForSupplyList])
    }

    function updateCart() {
        usingSupplyList.current = false;
        let nothingToUpdate = true;
        $('[id^="quantity-"]').each(function (i, row) {
            const quantity = parseInt($(row).val());
            var indexes = row.id.split('-');
            if (!items[indexes[1]]) return true;
            const currUoM = items[indexes[1]].UoMPrices[indexes[2]];
            const qtyDiff = quantity - currUoM.QtyOrdered;
            currUoM.QtyOrdered = quantity;
            currUoM.QtyDiff = qtyDiff;
            if (!!qtyDiff) nothingToUpdate = false;
        });
        if (nothingToUpdate) {
            setUpdateCart({ ItemList: [], ItemsAdded: 0, ItemsRemoved: 0 });
        }
        else {
            new AjaxPost({
                backdrop: true,
                endpoint: '/ShoppingCart/UpdateCart',
                payload: JSON.stringify(items),
                cbFunction: function (results) {
                    if (results.Cart) {
                        let cart = results.Cart;
                        let header = window.cartVM.header;
                        localStorage.setItem("CartSessionKey", cart.CartOrderNo.toString());
                        header.LocalKey(cart.CartOrderNo.toString());
                        header.ParseCartData(cart).then(() => header.UpdateRequestID());
                    }
                    setUpdateCart(results);
                },
                errFunction: function (err) { }
            });
        }
    }
}

function handleKeyDown(e, items, usingSupplyList) {
    if (e.which == 38) {
        changeQuantity(1, e, items, usingSupplyList);
        return;
    }
    if (e.which == 40) {
        changeQuantity(-1, e, items, usingSupplyList);
        return;
    }
    $(e.target).val($(e.target).val().replace(/[^\d].+/, ""));
    if (e.which !== 8 && !(e.which >= 37 && e.which <= 40) && e.which !== 46 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
    }
}

function handleInput(e, prevValue, items, usingSupplyList) {
    usingSupplyList.current = false;
    $(e.target).val() === '' ? $(e.target).val(0) : $(e.target).val(parseInt($(e.target).val()));
    $(e.target).val() > 9999 ? $(e.target).val(parseInt(prevValue.current)) : prevValue.current = $(e.target).val();
    updateTableIndicators(e, items);
}

function htmlBackorder(item) {
    return (<>
        {item.ALERTStatus && <div><div className="tw-font-bold">Backorder Status: </div><div className="tw-leading-[14px]">{item.ALERTStatus.replace(/"/g, "&quot;").replace(/'/g, "&#39;")}</div></div>}
        {item.ALERTOrgDate && <div><span className="tw-font-bold">Origination Date: </span>{item.ALERTOrgDate}</div>}
        {item.ALERTUpdateDate && <div><span className="tw-font-bold">Last Updated: </span>{item.ALERTUpdateDate}</div>}</>
    )
}

function changeQuantity(qty, e, items, usingSupplyList) {
    usingSupplyList.current = false;
    var input = $(e.target).siblings("input");
    if (!input.length) input = $(e.target);
    const prevQty = parseInt(input.val()) || 0;
    if (prevQty + qty < 0) return;
    const newQty = prevQty + qty;
    if (newQty > 9999) return;
    input.val(newQty);
    updateTableIndicators(input, items);
}

function updateTableIndicators(e, items) {
    updateSelectedItems(items);
    const target = e.target ? $(e.target) : e;
    target.val() > 0 ? target.parents('div').eq(0).css('border-color', '#62A94B') : target.parents('div').eq(0).css('border-color', '#E2E2E2');
}

function updateSelectedItems(items) {
    let selectedItems = 0;
    $('[id^="quantity-"]').each((i, row) => {
        const quantity = parseInt($(row).val());
        if (quantity) {
            selectedItems++;
            const [q, i, j] = $(row).prop('id').split('-');
            $(row).css('color', items[i]?.UoMPrices[j].QtyOrdered == quantity ? '#62A94B' : '#282828');
        }
        else $(row).css('color', '#282828');
    })
    if (selectedItems) {
        $('#selected-items').children().eq(0).text(selectedItems);
        $('#selected-items').children().eq(1).text(selectedItems == 1 ? "item selected" : "items selected");
        $('#selected-items').css("visibility", "visible");
    }
    else $('#selected-items').css("visibility", "hidden");
}